import axiosInstance from "../helpers/axiosInstance";

export const fetchWarehouseLocations = async (warehouse_id, params = {}) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouse_id}/locations`, { params: params, timeout: 25000 })
    return res.data
}

export const fetchAllWarehouseLocations = async (warehouse_id, params = {}) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouse_id}/warehouse-locations`, { params: params, timeout: 25000 })
    return res.data
}

export const fetchWarehouseLocationDetails = async (warehouse_id) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouse_id}/warehouse-location-details`)
    return res.data
}


export const exportWarehouseLocations = async (warehouse_id, params) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouse_id}/export-locations-by-product.csv`, {
        responseType: 'blob', // Important
        params: params
    })
    return res.data
}

export const enqueueLocationsExport = async function (data) {
    const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/user-async-tasks/locations_export`, data)
    return res.data
}

export const getLocationsExport = async function (jobId) {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/user-async-tasks/locations_export/${jobId}`)
    return res.data
}

export const fetchLocationContainers = async (warehouse_id, location_id) => {
    const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouse_id}/locations/${location_id}/containers`)
    return res.data
}

export const fetchLocationContainerCounts = async (warehouse_id, pairs) => {
    const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouse_id}/locations/container-counts`, { pairs })
    return res.data
}

export const createLocationBays = async (warehouse_id, data) => {
    const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouse_id}/create-location-bays`, data)
    return res.data
}

export const updateLocationBays = async (warehouse_id, data) => {
    const res = await axiosInstance.patch(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/warehouses/${warehouse_id}/update-location-bays`, data)
    return res.data
}